import { Navigate, Route, Routes } from "react-router-dom";
import NotFoundPage from "./pages/NotFoundPage";
import RedirectPage from "./pages/auth/RedirectPage";
import DeniedPage from "./pages/auth/DeniedPage";
import ScrollToTop from "./components/ui/ScrollToTop";
import { initCustomAlerts } from "./helpers/alertError";
import ProtectedNav from "./navigation/protected/ProtectedNav";
import LoginPage from "./pages/auth/LoginPage";
import { ErrorBoundary } from "./wrappers/ErrorBoundary";
import { useEffect } from "react";
import { setupErrorHandler } from "./utils/errorHandler";
import useAdminChatPush from "./hooks/support/chat/useAdminChatPush";
import NotificationAudioBanner from "./components/features/support/chat/NotificationAudioBanner";

function App() {
  // Initialiser le remplacement des alerts
  initCustomAlerts();

  useEffect(() => {
    setupErrorHandler();
  }, []);

  useAdminChatPush();

  return (
    <>
      <ScrollToTop>
        <ErrorBoundary>
          <NotificationAudioBanner />

          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/redirect" element={<RedirectPage />} />
            <Route path="/denied" element={<DeniedPage />} />
            <Route path="/*" element={<ProtectedNav />} />
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </ErrorBoundary>
      </ScrollToTop>
    </>
  );
}

export default App;
